import FoxpostPickupPicker from "./FoxpostPickupPicker";
import GlsPickupPicker from "./GlsPickupPicker";
import CheckoutAddressCard from "./CheckoutAddressCard";

function CheckoutLocationStep({
  t,
  lang,
  shippingMethod,
  shippingAddress,
  billingAddress,
  shippingSameAsBilling,
  pickupPoint,
  onShippingAddressChange,
  onBillingAddressChange,
  onShippingSameAsBillingChange,
  onPickupSelect,
}) {
  if (shippingMethod === "foxpostLocker") {
    return (
      <FoxpostPickupPicker t={t} selected={pickupPoint} onSelect={onPickupSelect} />
    );
  }

  if (shippingMethod === "glsLocker") {
    return (
      <GlsPickupPicker
        t={t}
        lang={lang}
        selected={pickupPoint}
        onSelect={onPickupSelect}
      />
    );
  }

  function handleBillingChange(next) {
    onBillingAddressChange(next);
    if (shippingSameAsBilling) {
      onShippingAddressChange(next);
    }
  }

  function handleSameAsBillingChange(checked) {
    onShippingSameAsBillingChange(checked);
    if (checked) {
      onShippingAddressChange({ ...billingAddress });
    }
  }

  return (
    <div className="checkout-contact checkout-address">
      <header className="checkout-contact-intro">
        <h3 className="checkout-section-title">{t.addressHeading}</h3>
        <p className="checkout-step-hint">{t.addressHint}</p>
      </header>

      <CheckoutAddressCard
        t={t}
        address={billingAddress}
        onChange={handleBillingChange}
        sectionTitle={t.billingSectionTitle}
        showFooter={shippingSameAsBilling}
      />

      <label className="checkout-same-address">
        <input
          type="checkbox"
          checked={shippingSameAsBilling}
          onChange={(event) => handleSameAsBillingChange(event.target.checked)}
        />
        <span>{t.shippingSameAsBilling}</span>
      </label>

      {!shippingSameAsBilling ? (
        <CheckoutAddressCard
          t={t}
          address={shippingAddress}
          onChange={onShippingAddressChange}
          sectionTitle={t.addressSectionTitle}
        />
      ) : null}
    </div>
  );
}

export default CheckoutLocationStep;
